import { jsx } from '@vtex/admin-ui-react'
import type { ComponentPropsWithRef } from 'react'

export const Box = jsx('div')({})

export type BoxProps = ComponentPropsWithRef<typeof Box>
